import { Brand } from '@promoboxx/graphql-gateway-types'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import {
  retailerIdsForCurrentBrandOrCurrentRetailerAccountSelector,
  currentRetailerAccountAndBrandSlugSelector,
  currentRetailerAccountSelector,
  brandsForCurrentRetailerAccountSelector,
} from '../../stores/app/selectors'

export type BrandsById = Record<string, Brand>

export const useCurrentIds = (): {
  resource_type: string
  resource_id: string
  parent_id: string
  brands: BrandsById
  retailerAccountId: string
} => {
  const brands = useSelector(brandsForCurrentRetailerAccountSelector)
  const { parent_id } = useParams<{ parent_id: string }>()
  const currentSlugs = useSelector(currentRetailerAccountAndBrandSlugSelector)
  const { id: retailerAccountId } = useSelector(currentRetailerAccountSelector)
  const retailerIds = useSelector(
    retailerIdsForCurrentBrandOrCurrentRetailerAccountSelector,
  )
  const resource_type =
    currentSlugs.brand === 'all' ? 'retailer_account' : 'retailer'
  const resource_id =
    currentSlugs.brand === 'all' ? retailerAccountId : retailerIds[0]

  const brandsById: BrandsById = brands.reduce(
    (acc: BrandsById, brand: Brand) => {
      acc[brand.id] = brand
      return acc
    },
    {},
  )

  return {
    resource_type,
    resource_id,
    parent_id,
    brands: brandsById,
    retailerAccountId,
  }
}
